import React from "react"

import Markdown from "markdown-to-jsx"

export const MarkdownElement: React.FunctionComponent<
    IMarkdownElementProps
> = props => {
    return <Markdown className={props.className}>{props.text}</Markdown>
}

interface IMarkdownElementProps {
    className?: string
    text: string
}
